import { Card, CardContent, Typography } from "@mui/material";
import type { JSX } from "react";

import { type Tone, toneColor } from "./securityFormat.js";

/**
 * A headline metric tile for the Security console (Events / Anomalous /
 * Blocked / Successful). The value colours by `tone` only when non-zero.
 * Extracted from `SecurityPanel.tsx`.
 */
export function StatTile({
  label,
  value,
  tone,
  hint,
}: {
  label: string;
  value: number;
  tone?: Tone;
  hint?: string;
}): JSX.Element {
  return (
    <Card>
      <CardContent sx={{ py: 2, "&:last-child": { pb: 2 } }}>
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: 500,
            textTransform: "uppercase",
            letterSpacing: "0.05em",
            color: "text.disabled",
          }}
        >
          {label}
        </Typography>
        <Typography sx={{ mt: 0.5, fontSize: 24, fontWeight: 600, color: toneColor(tone, value) }}>
          {value}
        </Typography>
        {hint && (
          <Typography sx={{ mt: 0.25, fontSize: 12, color: "text.disabled" }}>{hint}</Typography>
        )}
      </CardContent>
    </Card>
  );
}
